import { z } from 'zod';
import { skeletonBlockPropsSchema } from '../SkeletonBlock/SkeletonBlock';
import { skeletonTextPropsSchema } from '../SkeletonText/SkeletonText';
import {
  PROGRESS_LIST_CARD_MAX_ROWS,
  progressListCardCalloutSchema,
  progressListCardFooterSchema,
  progressListCardIndicatorSchema,
  progressListCardRowSchema,
} from './ProgressListCard';

const bodyLines = skeletonTextPropsSchema.shape.lines.removeDefault();
const calloutSchema = progressListCardCalloutSchema
  .pick({ title: true, body: true })
  .partial()
  .extend({ bodyLines: bodyLines.default(3) })
  .strict();
const footerSchema = progressListCardFooterSchema
  .pick({ title: true, body: true })
  .partial()
  .extend({ bodyLines: bodyLines.default(2) })
  .strict();
const rowSchema = progressListCardRowSchema
  .pick({ label: true, eyebrow: true, title: true, body: true })
  .partial()
  .extend({
    bodyLines: bodyLines.optional(),
    indicator: progressListCardIndicatorSchema.pick({ kind: true, total: true }).optional(),
    callout: calloutSchema.optional(),
  })
  .strict();

/** A loading sibling, with no completed counts, status, or interactive fields. */
export const progressListCardSkeletonPropsSchema = skeletonBlockPropsSchema
  .pick({ active: true, testID: true })
  .extend({
    rows: z.array(rowSchema).min(1).max(PROGRESS_LIST_CARD_MAX_ROWS),
    footer: footerSchema.optional(),
  })
  .strict();

export type ProgressListCardSkeletonProps = z.infer<typeof progressListCardSkeletonPropsSchema>;
